import React from 'react';
import { Heart, Shield, Zap, Tag } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-slate-100 to-slate-50">
      <Header />

      {/* Hero Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Tag className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            About <span className="text-slate-900">Peterhahn Fashion Coupon Club</span>
          </h1>
          <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto">
            Your trusted destination for finding the best coupon codes and deals from thousands of stores.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <Card className="border-2 border-slate-200">
              <CardContent className="p-6 sm:p-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">Our Mission</h2>
                <p className="text-slate-600 leading-relaxed">
                  At Peterhahn Fashion Coupon Club, we believe everyone deserves to save money on their purchases. Our mission is to make saving money easy, accessible, and rewarding by bringing you the latest and most reliable coupon codes from your favorite stores.
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 border-slate-200">
              <CardContent className="p-6 sm:p-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">What We Do</h2>
                <p className="text-slate-600 leading-relaxed">
                  We continuously search, verify, and update coupon codes from over 50 popular stores. Our team works around the clock to ensure you have access to working, verified deals that help you save real money on every purchase.
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Features Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-6 h-6 text-slate-900" />
                </div>
                <h3 className="font-semibold text-slate-900 mb-2">Verified Codes</h3>
                <p className="text-sm text-slate-600">All our coupon codes are tested and verified to work</p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Zap className="w-6 h-6 text-slate-900" />
                </div>
                <h3 className="font-semibold text-slate-900 mb-2">Real-Time Updates</h3>
                <p className="text-sm text-slate-600">Fresh deals updated daily from top brands</p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Tag className="w-6 h-6 text-slate-900" />
                </div>
                <h3 className="font-semibold text-slate-900 mb-2">50+ Stores</h3>
                <p className="text-sm text-slate-600">Access deals from your favorite brands</p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="w-6 h-6 text-slate-900" />
                </div>
                <h3 className="font-semibold text-slate-900 mb-2">100% Free</h3>
                <p className="text-sm text-slate-600">No hidden fees, completely free to use</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <Card className="bg-slate-900 border-0">
            <CardContent className="p-8 sm:p-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                Start Saving Today
              </h2>
              <p className="text-lg text-slate-300 mb-6">
                Join thousands of smart shoppers who save money every day with Peterhahn Fashion Coupon Club
              </p>
              <a
                href="/"
                className="inline-block bg-white text-slate-900 font-bold px-8 py-3 rounded-lg hover:bg-slate-100 transition-colors"
              >
                Browse Coupons
              </a>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
